interface BadgeCounterProps {
  count: number;
  dataMarker?: string;
}

const BadgeCounter = (props: BadgeCounterProps) => {
  const { dataMarker, count } = props;
  const countText = count > 99 ? '99+' : count;

  return (
    <span
      className="BadgeCounter"
      data-testid='badgeCounter'
      data-marker={dataMarker}
      title={count.toString()}
    >
      {countText}

      <style jsx>{`
      .BadgeCounter {
        display: inline-block;
        min-width: 15px;
        height: 16px;
        padding: 2px 4px;
        border: 1px solid var(--colors-white);
        border-radius: 14px;
        background-color: var(--colors-red);
        color: var(--colors-white);
        font-size: 10px;
        line-height: 10px;
        font-weight: 600;
        text-align: center;
      }
      `}</style>
    </span>
  );
};

export default BadgeCounter;
